import React from 'react';
import { Image, Pressable, Text, useWindowDimensions } from 'react-native';

import playButtonBackground from '../../assets/images/buttons/playButtonBackground.png';
import { styles } from './styles';

const PlayButton = ({ onPress }) => {
  const { height } = useWindowDimensions();

  return (
    <Pressable
      onPress={onPress}
      style={[
        styles.container,
        {
          marginTop: 0.05 * height,
        },
      ]}>
      <Image
        source={playButtonBackground}
        style={{
          height: 0.07 * height,
          width: 2.7294 * 0.07 * height,
          alignSelf: 'center',
          resizeMode: 'contain',
        }}
      />
      <Text
        style={[
          styles.text,
          {
            fontSize: 0.033 * height,
          },
        ]}>
        Jogar
      </Text>
    </Pressable>
  );
};

export default PlayButton;
